import PhotoSwipe from 'photoswipe';
import 'photoswipe/dist/photoswipe.css'; // tslint:disable-line
import './photoswipe.pcss';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default.js'; // tslint:disable-line

const namespace = 'photogallery';

export interface PhotoGalleryOptions {
  element: string;
  fullscreenEl: string;
  source: string;
  start_index: number;
}

type Options = Partial<PhotoGalleryOptions>;

export class PhotoGallery {
  static defaults: PhotoGalleryOptions = {
    element: '[data-gallery]',
    fullscreenEl: '[data-gallery-fullscreen]',
    source: '[data-gallery-images]',
    start_index: 0,
  };
  options: PhotoGalleryOptions;
  container: HTMLElement;
  el: HTMLElement;
  fullscreen: HTMLElement;
  instance: null;

  constructor(container: HTMLElement, options: Options = {}) {
    this.container = container;
    this.options = {
      ...PhotoGallery.defaults,
      ...this.container.dataset,
      ...options,
    };

    const el = this.container.querySelector(
      this.options.element,
    ) as HTMLElement;
    const fullscreen = document.querySelector(
      this.options.fullscreenEl,
    ) as HTMLElement;
    const imageData = document.querySelector(
      this.options.source,
    ) as HTMLScriptElement;

    if (!el || !fullscreen || !imageData) {
      return;
    }

    this.el = el;
    this.fullscreen = fullscreen;

    this.init(imageData.innerHTML);
  }

  init(data: string) {
    try {
      const imageJSON = JSON.parse(data);
      const instance = new PhotoSwipe(
        this.fullscreen,
        PhotoSwipeUI_Default,
        imageJSON.images,
        {
          closeOnScroll: false,
          closeOnVerticalDrag: false,
          fullscreenEl: false,
          history: false,
          index: this.options.start_index,
          loadingIndicatorDelay: 0,
          modal: true,
          zoomEl: false,
        },
      );

      instance.init();
      instance.zoomTo(
        0.5,
        {
          x: instance.viewportSize.x / 2,
          y: instance.viewportSize.y / 2,
        },
        1000,
      );
    } catch (e) {
      const errorEvent = new CustomEvent(`${namespace}:error`, {
        detail: e,
      });

      this.el.dispatchEvent(errorEvent);
    }
  }
}
